var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as baobab from '@data/baobab/baobab';
import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import DragAndDropWrapper from '../base/DragAndDropWrapper';
import LoadingAnimation from '../base/LoadingAnimation';
import { MaintenanceModeWrapper } from '../base/MaintenanceMode';
import { Tracking } from '../base/Tracking';
import { UnauthorizedWrapper } from '../base/Unauthorized';
import { engineApi } from '../data/rest/api';
import CommentsSidebar from '../main/comments/CommentsSidebar';
import { GlobalLoading } from '../shared/loading/globalLoading';
import TagsSidebar from '../shared/tagsSidebar/TagsSidebar';
import { handleApiErrorMessage } from '../util/message';
import HeaderNavbar from './HeaderNavbar';
var loadAppData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var expressionDataPromise;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                baobab.root.set(['models', 'forecastErrors'], {});
                expressionDataPromise = engineApi.getFunctionsData().then(function (functionsData) {
                    baobab.cursors.models.set('typeaheadfunctions', functionsData.en);
                });
                return [4 /*yield*/, Promise.all([expressionDataPromise])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
function Root() {
    var pathname = useLocation().pathname;
    var entryLinkKey = useParams().entryLinkKey;
    var _a = __read(useState(true), 2), isLoading = _a[0], setIsLoading = _a[1];
    var isEntryLink = pathname.includes('entrylink') && entryLinkKey;
    useEffect(function () {
        var isMounted = true;
        function initalLoad() {
            return __awaiter(this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, loadAppData()];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            handleApiErrorMessage(error_1);
                            return [3 /*break*/, 4];
                        case 3:
                            isMounted && setIsLoading(false);
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        initalLoad();
        return function () {
            isMounted = false;
        };
    }, []);
    if (isLoading) {
        return React.createElement(LoadingAnimation, { message: 'Loading...' });
    }
    return (React.createElement(DragAndDropWrapper, null,
        React.createElement(UnauthorizedWrapper, null,
            React.createElement(MaintenanceModeWrapper, null,
                React.createElement("div", null, isEntryLink ? (React.createElement("div", { style: { height: '100%', overflow: 'auto' } },
                    React.createElement(Outlet, null))) : (React.createElement("div", { className: "screen-wrapper", onMouseOver: function () {
                        document.documentElement.style.cursor = 'default';
                    } },
                    React.createElement(HeaderNavbar, null),
                    React.createElement("div", { className: "content-wrapper" },
                        React.createElement("div", { style: { flexGrow: 1, overflow: 'auto' } },
                            React.createElement(Outlet, null)),
                        pathname.includes('/sheet') || pathname.includes('/dashboard') ? (React.createElement(TagsSidebar, null)) : null,
                        pathname.includes('/sheet') ? React.createElement(CommentsSidebar, null) : null)))),
                React.createElement(GlobalLoading, null),
                React.createElement(Toaster, null),
                React.createElement(Tracking, null)))));
}
export default Root;
